<template lang="pug">
  .product-carousel__image-wrapper(@click="playVideo", :class="{ 'product-carousel__image-wrapper--video': hasVideo }")
    icon.product-carousel__play(v-if="hasVideo", name="play", :size="$mq === 'mobile' ? '50px' : '120px'")
    img.product-carousel__lab-seal(v-if="showLabSeal", :src="consumerLabSeal")
    img.product-carousel__image(:src="normalizedImage.src", :alt="imageAlt", draggable="false")
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue';
  import images from 'scripts/config/images.js';

  const VIDEO_PREFIX = 'video:';

  export default {
    name: 'ProductCarouselImage',
    components: { Icon },
    props: {
      image: [Object, String],
    },
    data () {
      return {
        consumerLabSeal: images.consumerLabSeal,
      };
    },
    computed: {
      normalizedImage () {
        // Handle both string URLs and object formats
        if (!this.image) {
          return { src: '', alt: '' };
        }
        if (typeof this.image === 'string') {
          return { src: this.image, alt: '' };
        }
        return {
          src: this.image.src || '',
          alt: this.image.alt || ''
        };
      },
      hasVideo () {
        return this.normalizedImage.alt && this.normalizedImage.alt.includes(VIDEO_PREFIX);
      },
      video () {
        return this.hasVideo ? this.normalizedImage.alt.replace(VIDEO_PREFIX, '') : null;
      },
      imageAlt () {
        return this.hasVideo ? 'Play Video' : this.normalizedImage.alt;
      },
      showLabSeal() {
        return this.imageAlt && this.imageAlt.toLowerCase().includes('consumer lab');
      },
    },
    methods: {
      playVideo () {
        if (this.hasVideo) {
          this.$store.dispatch('video/play', this.video);
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .product-carousel__image-wrapper {
    position: relative;
    display: flex;
    justify-content: center;

    @include tablet-up {
      max-width: 594px;
      max-height: 684px;
    }
  }

  .product-carousel__image-wrapper--video {
    cursor: pointer;
    position: relative;

    &:after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background-color: $color-transparent-black--light;
    }
  }

  .product-carousel__play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    fill: $text--light;
    z-index: 1;
  }

  .product-carousel__lab-seal {
    position: absolute;
    top: 30px;
    left: 10%;
    max-width: 18%;
  }

  .product-carousel__image {
    max-height: 100%;
    width: 100%;
    object-fit: contain;

    @include mobile-only {
      max-height: 370px;
    }
  }
</style>
